import { render, staticRenderFns } from "./salary_base.vue?vue&type=template&id=7c791a44&scoped=true"
import script from "./salary_base.vue?vue&type=script&lang=js"
export * from "./salary_base.vue?vue&type=script&lang=js"
import style0 from "./salary_base.vue?vue&type=style&index=0&id=7c791a44&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c791a44",
  null
  
)

export default component.exports